import Container from "react-bootstrap/Container";
import MainBG from "../../assets/images/main-bg.jpg";
import MainBGMobile from "../../assets/images/main-bg-mobile.jpg";
import Header from "../Header";
import "./HeroSection.css";

export default function HeroSection(props) {
  return (
    <Container fluid className="hero-section">
      <Header />
      <a
        href={props.whatsAppNumber}
        rel="noopener noreferrer"
        target="_blank"
        aria-label="Entre em contato via WhatsApp"
      >
        <img
          src={MainBG}
          alt="Campanha Vida Premiada"
          className="hero-background"
        />
        <img
          src={MainBGMobile}
          alt="Campanha Vida Premiada"
          className="hero-background-mobile "
        />
      </a>
    </Container>
  );
}
